<template>
  <div
    class="
      tw-bg-white
      tw-max-w-[90vw]
      tw-mx-auto
      tw-pb-9
      tw-pt-4
      tw-px-6
      tw-text-center
      xl:tw-max-w-[40vw]
    "
  >
    <div class="tw-text-right tw-text-xs">
      <button @click="$emit('close')">{{ closeText }}</button>
    </div>

    <img class="tw-h-[80px] tw-mb-4 tw-mx-auto" src="/logo.png" />
    <p
      v-if="title"
      :class="{
        'tw-mb-5': description,
        'tw-mb-7': !description,
      }"
      class="tw-font-medium tw-text-2xl"
    >
      {{ title }}
    </p>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <p v-if="description" class="tw-mb-9 tw-text-base" v-html="description" />
    <component :is="icon" v-if="icon" class="tw-mx-auto tw-text-6xl" />
    <div
      class="
        tw-flex tw-flex-col tw-justify-center tw-mx-auto tw-w-3/4
        xl:tw-w-1/2
      "
    >
      <button
        v-for="(option, index) in options"
        :key="index"
        :class="option.class"
        class="tw-mb-3.5 tw-py-3 tw-text-black"
        @click="option.onClick"
      >
        {{ option.title }}
      </button>
    </div>
  </div>
</template>

<script>
import CheckIcon from 'vue-material-design-icons/CheckCircle'
import AlertIcon from 'vue-material-design-icons/AlertCircle'
import CheckCircleGreenIcon from '@/assets/icons/check_circle_green.svg?inline'

export default {
  components: {
    CheckIcon,
    CheckCircleGreenIcon,
    AlertIcon,
  },
  props: {
    closeText: {
      default() {
        return this.$t('modal__cancel')
      },
      required: false,
      type: String,
    },
    options: {
      default: () => [],
      required: false,
      type: Array,
    },
    description: {
      default: '',
      type: String,
    },
    icon: {
      default: null,
      required: false,
      type: String,
    },
    title: {
      default: '',
      required: false,
      type: String,
    },
  },
}
</script>
